import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface BannerState {
  isBannerVisible: boolean;
}

interface BannerActions {
  setBannerVisible: (visible: boolean) => void;
  initializeBannerState: () => void;
  closeBanner: () => void;
}

const initialState: BannerState = {
  isBannerVisible: !localStorage.getItem('bannerClosed') && location.pathname === '/',
};

export const useBannerStore = create(
  immer<BannerState & BannerActions>((set) => ({
    ...initialState,

    setBannerVisible: (visible) => {
      set({ isBannerVisible: visible });
    },

    initializeBannerState: () => {
      set({ isBannerVisible: !localStorage.getItem('bannerClosed') && location.pathname === '/' });
    },

    closeBanner: () => {
      localStorage.setItem('bannerClosed', 'true');
      set({ isBannerVisible: false });
    },
  })),
);
